import * as ft from 'focus-trap'

class MegaMenu {
    constructor(element) {
        this.button = element
        this.isOpen = false

        if (!this.button || !this.menu) return

        this.trap = ft.createFocusTrap(this.menu, {
            allowOutsideClick: true,
            initialFocus: false,
        })

        this.bindClickEvent()
        this.bindKeydownEvent()
        this.bindPointerEvents()
        this.bindTransitionEndEvent()
        this.observePanels()
    }

    get wrapper() {
        return this.button.parentElement
    }

    get menu() {
        return document.querySelector(`#${this.button.getAttribute('aria-controls')}`)
    }

    get firstTab() {
        return this.menu.querySelector('[role="tab"][tabindex="0"]')
    }

    get panels() {
        return this.menu.querySelectorAll('[role="tabpanel"]')
    }

    bindClickEvent() {
        this.button.addEventListener('click', this.toggle.bind(this))
        document.addEventListener('click', (event) => {
            if (this.isOpen && !this.menu.contains(event.target) && !this.button.contains(event.target)) {
                this.close()
            }
        })
    }

    bindKeydownEvent() {
        document.addEventListener('keydown', (event) => (event.key === 'Escape' && this.isOpen) && this.close())
    }

    bindPointerEvents() {
        this.wrapper.addEventListener('mouseenter', this.open.bind(this))
        this.wrapper.addEventListener('mouseleave', this.close.bind(this))
    }

    bindTransitionEndEvent() {
        this.menu.addEventListener('transitionend', (event) => {
            if (event.propertyName === 'visibility' && this.isOpen) {
                this.firstTab?.focus()
                this.trap.activate()
            }
        })
    }

    observePanels() {
        this.panels.forEach((panel) => {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    const { isIntersecting, target } = entry

                    if (isIntersecting) {
                        if (target.scrollHeight > target.clientHeight) {
                            target.classList.add('has-scrollbar')
                        } else {
                            target.classList.remove('has-scrollbar')
                        }
                    }
                })
            })
            observer.observe(panel)
        })
    }

    toggle() {
        this.isOpen ? this.close() : this.open()
    }

    open() {
        this.isOpen = true
        this.menu.classList.remove('mega-menu-hidden')
        this.menu.classList.add('mega-menu-open')
        this.button.setAttribute('aria-expanded', 'true')
    }

    close() {
        this.isOpen = false
        this.menu.classList.remove('mega-menu-open')
        this.menu.classList.add('mega-menu-hidden')
        this.button.setAttribute('aria-expanded', 'false')
        this.trap.deactivate()
        this.button.focus()
    }

    static init() {
        return new MegaMenu(document.querySelector('[data-mega-menu-toggle]'))
    }
}

export default MegaMenu
